import type {
    PrimaryPMSDKComponent,
    IPrimaryBasicData,
    IPrimaryCommonProps,
} from '@fiverr-private/primary_section_sdk';
import { ProjectManagerCard, ProjectManagementModal } from './components';

export const PrimaryProjectManagementSDKComponentImpl: PrimaryPMSDKComponent<IPrimaryBasicData & IPrimaryCommonProps> =
    {
        PrimaryComponent: ProjectManagerCard,
        ProjectManagementModal,
    };
